import heroBg from '@/assets/explain/bg.png';
import section1Img1 from '@/assets/explain/feature-1.png';
import section1Img2 from '@/assets/explain/feature-2.png';
import section1Img3 from '@/assets/explain/feature-3.png';
import techBg from '@/assets/explain/tech-bg.png';
import techIcon1 from '@/assets/explain/icon-1.png';
import techIcon2 from '@/assets/explain/icon-2.png';
import techIcon3 from '@/assets/explain/icon-3.png';

export const HERO = {
  title: '爱学AI拍讲智能体',
  image: heroBg,
  subtitle: (
    <>
      爱学AI拍讲智能体是一款基于认知诊断模型与生成式AI的交互式学习引擎，
      <br />
      能够理解题目逻辑、拆解解题过程，并结合学习者当前的知识状态，动态调整讲解方式与深度，
      <br />
      不止提供答案，更帮助学习者理解思路、建立逻辑，实现从“答案检索”到“逻辑建构”的范式跃迁。
    </>
  ),
};

export const FEATURE = {
  title: '爱学拍讲，三大核心设计',
  subTitle: '让学习从“知道答案”走向“掌握思维”',
  cards: [
    {
      title: '即拍即讲，引导式拆解',
      description:
        '一拍即讲，从审题到推导逐层精讲，每一步都有实时小结，扫除盲区，培养独立思考习惯。',
      visualBackground: 'linear-gradient(to left, #daf5ff, #d6ebff)',
      image: section1Img1,
      reverse: false,
    },
    {
      title: '个性化适配，因人导学',
      description:
        '根据学习者的反应节奏动态调整讲解策略，适时设问、点拨思维，让每个人都能听得懂、跟得上、学得透。',
      visualBackground: 'linear-gradient(to right, #f6e5ff, #e5efff)',
      image: section1Img2,
      reverse: true,
    },
    {
      title: '智能解析，高手心法',
      description:
        '自研大模型经海量真实学习场景训练，不仅讲清步骤，更传递优秀解题思维与方法，一题学透，举一反三。',
      visualBackground: 'linear-gradient(to left, #daf5ff, #d6ebff)',
      image: section1Img3,
      reverse: false,
    },
  ],
};

export const TECH = {
  titleLines: ['三大技术', '定义AI讲题新标准'],
  subTitle: '硬核技术底座，让每一次讲题都专业、高效、有温度',
  background: techBg,
  points: [
    {
      title: '多模态识别与 Agent 协同调度',
      description:
        '精准匹配图文公式并结构化，通过模块化能力中枢统一调度识别、推理、生成等Agent，保障从识别到讲解的全程高效协同。',
      icon: techIcon1,
    },
    {
      title: '个性化学习引擎与动态编排',
      description:
        '内容×交互×引导三维适配，智能控制讲题流程，实时生成 SVG 动态板书，边讲边画使抽象思维可视化，决策随学情调整。',
      icon: techIcon2,
    },
    {
      title: '沉浸式互动与低延迟驱动',
      description:
        '支持实时语音打断与互动问答，配合低延迟交互，营造如真人导师般的沉浸式学习体验，让互动更自然、学习更专注。',
      icon: techIcon3,
    },
  ],
};
